var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgArrowRightBold(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 17 15",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.125 8.9101V5.5351C0.125 5.30072 0.207031 5.1015 0.371094 4.93744C0.535156 4.77338 0.734375 4.69135 0.96875 4.69135H8V1.0351C8 0.660095 8.17578 0.402283 8.52734 0.261658C8.87891 0.121033 9.18359 0.179626 9.44141 0.437439L15.6289 6.62494C16.0273 7.02338 16.0273 7.42181 15.6289 7.82025L9.44141 14.0078C9.18359 14.2656 8.87891 14.3242 8.52734 14.1835C8.17578 14.0429 8 13.7851 8 13.4101V9.75385H0.96875C0.734375 9.75385 0.535156 9.67181 0.371094 9.50775C0.207031 9.34369 0.125 9.14447 0.125 8.9101Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowRightBold);
export default __webpack_public_path__ + "static/media/arrow-right-bold.4bd931c1bab113a232b2ac77473c5eeb.svg";
export { ForwardRef as ReactComponent };